






import { DebugHelper } from "@/helper/debugHelper";
import { Component, Vue } from "vue-property-decorator";

@Component({
  components: {
  }
})
export default class AdjustedBalloon extends Vue
{
  private topPosition : string = "";

  mounted() {
    window.addEventListener("resize", this.onResize);
    this.adjust();
  }
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  }

  onResize() {
    this.topPosition = "auto";
    this.$nextTick(() => this.adjust());
  }

  adjust() {
    let element = this.$refs["myElement"] as HTMLDivElement;
    let clientRect = element.getBoundingClientRect();
    let overHeight = clientRect.bottom - window.innerHeight;
    if(overHeight > 0) {
      DebugHelper.trace("AdjustedBalloon adjust: " + overHeight);
      this.topPosition = `${element.offsetTop - overHeight}px`;
    } else {
      DebugHelper.trace("AdjustedBalloon adjust: none");
    }
  }
}
